export default {
    test(state,val){
        state.user.phone = val;
    },
    setUserInfo(state, val){
        for (let i in val) {
            state.usercenter[i] = val[i];
        }
    },
    setCompanyInfo(state, val){
        for (let i in val) {
            state.company[i] = val[i];
        }
    },
    setLockStatus(state,val){
        state.lockStatus = val;
    },
    setAppointStatus(state,val){
        state.appointModal.open = val;
    },
    setAppointData(state,val){
        if( val.type ) {
            state.appointModal.data = val.data;
        }else{
            state.appointModal.data[val.key] = val.value;
        }
    },
    setRegStatus(state,val){
        state.regModal.open = val;
    },
    setRegData(state,val){
        if( val.type ) {
            state.regModal.data = val.data;
        }else{
            state.regModal.data[val.key] = val.value;
        }
    },
    setTeethInfo(state, val){
        for (let i in val) {
            state.teethInfoArr[i] = val[i];
        }
    },
    setWSStatus(state,val){
        state.wSocket = val;
    },
    setPlanWhitePhones(state,data){
        state.planWhitePhones = data
    }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js